import { render } from "./adminEdit.vue?vue&type=template&id=544ab511&scoped=true"
import script from "./adminEdit.vue?vue&type=script&lang=js"
export * from "./adminEdit.vue?vue&type=script&lang=js"

import "./adminEdit.vue?vue&type=style&index=0&id=544ab511&lang=scss&scoped=true"

import exportComponent from "I:\\2019projectALL\\PHP\\phpstudy\\WWW\\Composer\\2025\\appoinment\\appoinmentWebV3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544ab511"]])

export default __exports__